import React from 'react';

// Nexus Core Design System (DESIGN.md §5.2) - Status Badge
const variants = {
  default: 'bg-light-neutral text-text-secondary',
  primary: 'bg-nexus-blue-soft text-nexus-primary',
  success: 'bg-emerald-50 text-emerald-700',
  warning: 'bg-amber-50 text-amber-700',
  danger: 'bg-red-50 text-red-700',
  info: 'bg-sky-50 text-sky-700',
};

const sizes = {
  sm: 'px-2 py-0.5 text-[0.7rem]',
  md: 'px-2.5 py-0.5 text-xs',
};

export default function Badge({
  children,
  variant = 'default',
  size = 'md',
  icon,
  className = '',
  ...props
}) {
  const variantClasses = variants[variant] || variants.default;
  const sizeClasses = sizes[size] || sizes.md;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md font-medium ${variantClasses} ${sizeClasses} ${className}`}
      {...props}
    >
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {children}
    </span>
  );
}
